import EmailActivityInput from './EmailActivityInput';

export default EmailActivityInput;
